export const ReceivedPaymentFormFields = [{
  name: 'name',
  type: 'text',
  required: true
}, {
  name: 'purpose',
  type: 'text',
  required: true
// }, {
//   name: 'amount',
//   type: 'text',
//   required: true
}];
